import { Announcement, AnnouncementStatus, OwnerType, PropertyType, AnnouncementType } from '../models/announcement.model';

export const MOCK_LISTING_DETAILS: Announcement[] = [
  {
    id: 1,
    status: AnnouncementStatus.Active,
    price: 375000,
    area_m2: 81,
    rooms: 3,
    floor: 8,
    total_floors: 9,
    address: 'Gənclik m.',
    region: 'Bakı, Nərimanov r.',
    propertyType: PropertyType.NewBuild,
    type: AnnouncementType.Sale,
    ownerType: OwnerType.Owner,
    repair: 'Təmirli',
    hasExtract: true,
    hasMortgage: true,
    description: 'Təcili satılır! Gənclik metrosunun yaxınlığında, premium binada 3 otaqlı mənzil. Mənzil tam təmirlidir, bütün sənədləri qaydasındadır (Çıxarış var). Binada qaz, su, işıq daimidir. Həyətində uşaq meydançası və parkinq mövcuddur.',
    createdAt: new Date('2026-05-07T11:05:00'),
    createdDate: new Date('2026-05-07T11:05:00'),
    expiresAt: new Date(Date.now() + 30 * 24 * 60 * 60 * 1000),
    imageUrls: [
      'https://images.unsplash.com/photo-1522708323590-d24dbb6b0267?q=80&w=2070&auto=format&fit=crop',
      'https://images.unsplash.com/photo-1502672260266-1c1ef2d93688?q=80&w=2080&auto=format&fit=crop',
      'https://images.unsplash.com/photo-1484154218962-a197022b5858?q=80&w=2074&auto=format&fit=crop',
      'https://images.unsplash.com/photo-1493809842364-78817add7ffb?q=80&w=2070&auto=format&fit=crop',
      'https://images.unsplash.com/photo-1560448204-e02f11c3d0e2?q=80&w=2070&auto=format&fit=crop'
    ],
    contactName: 'Elvin Məmmədov',
    contactPhone: '+994 50 123 45 67',
    isVip: true,
    vipExpiresAt: new Date(Date.now() + 5 * 24 * 60 * 60 * 1000),
    lat: 40.400,
    lng: 49.850,
    viewCount: 1245
  },
  {
    id: 2,
    status: AnnouncementStatus.Pending,
    price: 1200,
    area_m2: 65,
    rooms: 2,
    floor: 3,
    total_floors: 5,
    address: 'Azadlıq pr.',
    region: 'Bakı, Nəsimi r.',
    propertyType: PropertyType.OldBuild,
    type: AnnouncementType.Rent,
    ownerType: OwnerType.Agent,
    repair: 'Təmirli',
    hasExtract: true,
    hasMortgage: false,
    description: 'Nəsimi rayonunda, Azadlıq prospektində yerləşən 2 otaqlı mənzil kirayə verilir. Mənzil tam əşyalıdır.',
    createdAt: new Date(),
    createdDate: new Date(),
    expiresAt: new Date(Date.now() + 30 * 24 * 60 * 60 * 1000),
    imageUrls: [
      'https://images.unsplash.com/photo-1493809842364-78817add7ffb?q=80&w=2070&auto=format&fit=crop'
    ],
    contactName: 'Nigar Xəlilova',
    contactPhone: '+994 55 987 65 43',
    isVip: false,
    lat: 40.410,
    lng: 49.840,
    viewCount: 320
  }
];
